const Base = require('./desktop');
const createEditable = require('./createEditable');

module.exports = createEditable(Base);
